<template>
  <ym-img class="qr-code-component"
          :class="[
             `size-${size}`
           ]"
          :src="src"
          :alt="alt"
  />
</template>

<script>
  export default {
    name: 'QrCode',
    props: {
      src: {
        type: String,
        required: true,
      },
      alt: {
        type: String,
        default: '二维码',
      },
      size: {
        type: String,
        validator(val) {
          return [
            'normal',
          ].includes(val);
        },
        default: 'normal',
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @qr-code-normal-size: 258px;
  .qr-code-component {
    display: inline-block;
    border: @border-base;
    &.size-normal {
      width: @qr-code-normal-size;
      height: @qr-code-normal-size;
    }
  }
</style>
